import { Localization } from "../../../common/localizable-component";
import { LinkLocalization } from "./contact-bar-types";

export const LINK_LOCALIZATION: Localization<LinkLocalization> = {
  en: {
    ariaLabel: {
      mail: "Send a mail to {0}",
      phone: "Call phone number {0}",
      faq: "Navigate for FAQ on {0}"
    }
  },
  de: {
    ariaLabel: {
      mail: "Verfasse eine E-Mail an {0}",
      phone: "Rufe {0} an",
      faq: "Navigieren für FAQ auf {0}"
    }
  },
  sv: {
    ariaLabel: {
      mail: "Skicka e-post till {0}",
      phone: "Ring telefonnummer {0}",
      faq: "Gå till FAQ på {0}"
    }
  },
  nl: {
    ariaLabel: {
      mail: "Stuur een e-mail naar {0}",
      phone: "Bel telefoonnummer {0}",
      faq: "Navigeer voor FAQ naar {0}"
    }
  },
  it: {
    ariaLabel: {
      mail: "Manda una mail a {0}",
      phone: "Chiama il numero di telefono {0}",
      faq: "Naviga per le FAQ su {0}"
    }
  },
  hu: {
    ariaLabel: {
      mail: "Üzenet küldése {0}",
      phone: "Telefonszám hívása {0}",
      faq: "Tovább a Gyakran Ismételt Kérdésekhez {0}"
    }
  },
  da: {
    ariaLabel: {
      mail: "Send mail til {0}",
      phone: "Ring til nummer {0}",
      faq: "Gå til FAQ om {0}"
    }
  },
  fr: {
    ariaLabel: {
      mail: "Envoyer un mail à {0}",
      phone: "Appeler le numéro de téléphone {0}",
      faq: "Naviguer pour FAQ sur {0}"
    }
  },
  es: {
    ariaLabel: {
      mail: "Enviar un email a {0}",
      phone: "Llama al número de teléfono {0}",
      faq: "Navegar por FAQ en {0}"
    }
  },
  pl: {
    ariaLabel: {
      mail: "Wyślij maila na adres {0}",
      phone: "Zadzwoń pod numer telefonu {0}",
      faq: "Przejdź do FAQ na stronie {0}"
    }
  },
  ro: {
    ariaLabel: {
      mail: "Trimiteți un e-mail la {0}",
      phone: "Sună la numărul de telefon {0}",
      faq: "Navigați pentru FAQ pe {0}"
    }
  },
  hr: {
    ariaLabel: {
      mail: "Pošalji e-poštu na {0}",
      phone: "Nazovi telefonski broj {0}",
      faq: "Navigirajte za FAQ na {0}"
    }
  },
  cs: {
    ariaLabel: {
      mail: "Pošlete mail na {0}",
      phone: "Volejte na telefonní číslo {0}",
      faq: "Přejít na často kladené dotazy na {0}"
    }
  },
  sl: {
    ariaLabel: {
      mail: "Pošljite pošto na {0}",
      phone: "Pokličite telefonsko številko {0}",
      faq: "Pojdite po pogosto zastavljenih vprašanjih na {0}"
    }
  }
};
